export default "__VITE_ASSET__Ca_AA8gf__"